(ns journal-app-client.events
  (:require [journal-app-client.utils.common :as common]
            [journal-app-client.views :as views]
            [re-frame.core :as rf]
            [ajax.core :refer [json-request-format json-response-format]]
            [day8.re-frame.http-fx]
            [journal-app-client.routes :as routes]
            [journal-app-client.db :refer [default-db]]
            [journal-app-client.config :as config]))

(rf/reg-event-fx :initialize-db
  (fn [{:keys [current-db]} [_ _]]
    (let [new-db (merge default-db current-db)
          initial-selected-view (:selected-view new-db)]
      {:db new-db
       :fx [(when-not (false? (:push-state? (second initial-selected-view)))
              [:routes-push-state initial-selected-view])]})))

(rf/reg-event-fx :select-view
  (fn [{:keys [db]} [_ view props]]
    (views/select-view view props (assoc db :user (or (:user-uuid db) (:local-storage-user-uuid db))))))

(rf/reg-event-fx :login
  (fn [{:keys [db]} [_ use-state]]
    (let [[state _] use-state]
      {:db (assoc-in db [:loading :login] true)
       :fx [[:http-xhrio {:method          :post
                          :uri             ""
                          :format          (json-request-format)
                          :response-format (json-response-format)
                          :timeout         15000
                          :on-success      [:login-success use-state]
                          :on-failure      [:request-failure :login]}]]})))

(rf/reg-event-fx :login-success
  (fn [{:keys [db]} [_ use-state resp]]
    (let [[state set-state] use-state]
      (set-state (assoc state :email-sent? true))
      {:fx [[:dispatch [:request-success :login resp]]]})))

(rf/reg-event-fx :logout
  (fn [{:keys [db]}]
    {:db (assoc-in db [:loading :logout] true)
     :fx [[:http-xhrio {:method          :post
                        :uri             ""
                        :format          (json-request-format)
                        :response-format (json-response-format)
                        :timeout         15000
                        :on-success      [:logout-success]
                        :on-failure      [:request-failure :logout]}]]}))

(rf/reg-event-fx :logout-success
  (fn [{:keys [db]} [_ _]]
    {:db (assoc-in db [:loading :logout] false)
     :fx [[:dispatch [:close-modal]]]}))